export enum AdminPermission {
  ROLE_BUYER_CPA_EXECUTE = 'ROLE_BUYER_CPA_EXECUTE',
  ROLE_BUYER_RFP_SEND = 'ROLE_BUYER_RFP_SEND',
  ROLE_BUYER_PURCHASE_PLAN_EDIT = 'ROLE_BUYER_PURCHASE_PLAN_EDIT',
  ROLE_BUYER_ORG_PROFILE_EDIT = 'ROLE_BUYER_ORG_PROFILE_EDIT',
  ROLE_BUYER_VALUE_ANALYSIS = 'ROLE_BUYER_VALUE_ANALYSIS',
  BUYER_VIEW_PARTNER_DETAIL = 'BUYER_VIEW_PARTNER_DETAIL',
  VIEW_ACTIVE_SPEND_HISTORY = 'VIEW_ACTIVE_SPEND_HISTORY',
  VIEW_PREVIEW_SPEND_HISTORY = 'VIEW_PREVIEW_SPEND_HISTORY',
  ROLE_SELLER_RFP_RESPOND = 'ROLE_SELLER_RFP_RESPOND',
  ROLE_SELLER_ORG_PROFILE_EDIT = 'ROLE_SELLER_ORG_PROFILE_EDIT',
  ROLE_SELLER_XREF_EDIT = 'ROLE_SELLER_XREF_EDIT',
  ROLE_SELLER_CPA_EXECUTE = 'ROLE_SELLER_CPA_EXECUTE',
  ROLE_SELLER_PRICE_MODEL_EDIT = 'ROLE_SELLER_PRICE_MODEL_EDIT',
  ROLE_SELLER_MIN_MAX_PRICING_EDIT = 'ROLE_SELLER_MIN_MAX_PRICING_EDIT',
  ROLE_CROSS_REFERENCE_EDIT = 'ROLE_CROSS_REFERENCE_EDIT',
  ROLE_VIZIENT_EMPLOYEE = 'ROLE_VIZIENT_EMPLOYEE',
  ROLE_ADMIN_CREATE_EDIT_USER = 'ROLE_ADMIN_CREATE_EDIT_USER',
  ROLE_LIMITED_APTADMIN = 'ROLE_LIMITED_APTADMIN',
  ROLE_SELLER_ADMIN = 'ROLE_SELLER_ADMIN',
  ROLE_APTITUDE_ADMIN = 'ROLE_APTITUDE_ADMIN',
  ROLE_GPO_ADMIN = 'ROLE_GPO_ADMIN',
  ROLE_BUYER_ADMIN = 'ROLE_BUYER_ADMIN',
  ROLE_TOGGLZ_ADMIN = 'ROLE_TOGGLZ_ADMIN',
  ADMIN_GENERATE_REPORTS = 'ADMIN_GENERATE_REPORTS',
}
